import React, { useState, useEffect } from "react"
import { getDettaglioPagamenti } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import * as Constants from '../../utils/constants'
import {
  Container,
  Row,
  Col,
  Button
} from 'design-react-kit';

export const SibaMostraDettagliPagamento = ({ schedaPagamento, veicolo, handleSubmit }) => {

  const [dettaglioPagamenti, setDettaglioPagamenti] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      let annoDiImposta = Number(schedaPagamento.anno)+1;
      if(schedaPagamento.risultato.toString() === Constants.MODO_PAGAMENTO_NON_ANNUALE){
        annoDiImposta = Number(schedaPagamento.anno);
      }
      if(isStorico(schedaPagamento)){
        annoDiImposta = Number(schedaPagamento.anno);
      } else if(schedaPagamento.scadenza !== undefined && schedaPagamento.scadenza.includes('/')){
      let datiScadenza = schedaPagamento.scadenza.split('/');
        if(datiScadenza.length === 2) {
          annoDiImposta = Number(datiScadenza[1]);
        }
      }
      console.log("MM " + annoDiImposta)
      const responseDettaglioPagamenti = await getDettaglioPagamenti(annoDiImposta, veicolo.idVeicolo);
      console.log("responseDettaglioPagamenti=", responseDettaglioPagamenti);
      if (responseDettaglioPagamenti === undefined) {
        console.log('Pagamento %s per veicolo %s non trovato', annoDiImposta, veicolo.idVeicolo)
        setDettaglioPagamenti([])
        setLoading(false)
        return
      }
      setDettaglioPagamenti(responseDettaglioPagamenti)
      setLoading(false)
    }
    fetchData();
  }, []);

  useEffect(() => {
    moveFocusTo("chiudi_dettaglio");
  });

  const drawTableHeader = (numeroProgressivo) => {
    return numeroProgressivo === 0 ? React.Fragment : (
      <thead>
        <tr>
          <th>Pagamento </th>
          <th>#{numeroProgressivo}</th>
        </tr>
      </thead>
    )
  }

  const isStorico = (schedaPagamento) => {
    return schedaPagamento.risultato.includes("storico");
  }

  const drawSeparator = () => {
    return <><br /><hr /></>;
  }

  const showAlertNoPagamenti = (dettaglioPagamenti) => {
    if(dettaglioPagamenti.length == 0){
      if(schedaPagamento.risultato.includes("storico")){
        return (<>
                    <br/>Nessun pagamento trovato per l'anno {schedaPagamento.anno} <br/>
                    <br/>Il pagamento della tassa di circolazione può essere effettuato nella sezione <strong>Calcola e Paga</strong> <br/><br/>
                </>);
      } else {
          return (<>
                      <br/>Nessun pagamento trovato per l'anno {schedaPagamento.anno} <br/><br/>
                  </>);
        
      }
    } else {
      return(<></>);
    }

  }

  const drawTable = (dettaglioPagamento, numeroProgressivo) => {
    console.log("dettagliPagamento=", dettaglioPagamento, "numeroProgressivo", numeroProgressivo)
    return (
      <div>
        {drawSeparator()}
        <table className="table table-striped table-sm" id="vertical-1">
          {drawTableHeader(numeroProgressivo)}
          <tbody>
            <tr>
              <th>Targa</th>
              <td>{dettaglioPagamento.targa}</td>
            </tr>
            <tr>
              <th>Tipo</th>
              <td>{dettaglioPagamento.tipoVeicolo.descrizione}</td>
            </tr>
            {/* <tr>
              <th>Beneficiario</th>
              <td>{dettagliPagamento.regioneBeneficiaria.descrizione}</td>
            </tr>
            <tr>
              <th>Incassato da</th>
              <td>{dettagliPagamento.regioneIncasso.descrizione}</td>
            </tr> 
            <tr>
              <th>Dati Calcolo</th>
              <td>{dettagliPagamento.datiCalcolo}</td>
            </tr>*/}
            {/*<tr>
              <th>Intermediario</th>
              <td>{dettaglioPagamento.tipoIntermediario.descrizione}</td>
          </tr>*/}
            {/* <tr>
              <th>Tipo</th>
              <td>{dettagliPagamento.tipoVeicolo.descrizione}</td>
            </tr> */}
            {/* <tr>
                <th>Data pagamento effettuato</th>
                <td>{dettagliPagamento.dataPagamentoEffettuato}</td>
              </tr> */}
            <tr>
              <th>Data</th>
              <td>{dettaglioPagamento.dataPagamentoEffettuato}</td>
            </tr>
            <tr>
              <th>Scadenza</th>
              <td>{dettaglioPagamento.dataScadenza.mese.descrizione}-{dettaglioPagamento.dataScadenza.anno}</td>
            </tr>
            <tr>
              <th>Validità</th>
              <td>{dettaglioPagamento.validita}</td>
            </tr>
            <tr>
              <th>Ricevuta</th>
              <td>{dettaglioPagamento.numeroRicevuta}</td>
            </tr>
            {/* <tr>
              <th>Proprietario</th>
              <td>{dettagliPagamento.identificativoFiscaleProprietarioOriginale}</td>
            </tr> */}
            <tr>
              <th>Importo totale</th>
              <td><strong>{dettaglioPagamento.importo.totale.importo.toFixed(2)}</strong> {dettaglioPagamento.importo.totale.divisa.descrizione}</td>
            </tr>
          </tbody>
          {/* {drawTableFooter(numeroProgressivo)} */}
        </table>
      </div>
    )
  }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="mostraDettaglioPagamento" tag="section">
      <Row>
        <Col>
          <h3>Dettagli Pagamento</h3>
          {dettaglioPagamenti.length === 1 ? (
            drawTable(dettaglioPagamenti[0], 0)
          ) : (
            dettaglioPagamenti.map((dettagliPagamento, i) => (
              drawTable(dettagliPagamento, ++i)
            )))}
        </Col>
      </Row>
      <Row>
        <Col />
        <Col>
          {showAlertNoPagamenti(dettaglioPagamenti)}
        </Col>
        <Col />
      </Row>
      <Button id="chiudi_dettaglio" className="btn btn-primary" size="xs" color="primary" icon={false} tag="button" onClick={handleSubmit} >
        Chiudi dettaglio
      </Button>
    </Container>
  )
}

export default SibaMostraDettagliPagamento;